import * as numberToWords from 'number-to-words';

import { DatePipe } from '@angular/common';

import { FileModel } from './file-item.model';

export class PWUtils {

  // tslint:disable-next-line:ban-types
  static enumToArray(data: Object): {
    key: string;
    name: string;
  }[] {
    const arr = Object.keys(data).map(x => ({
      key: x,
      name: this.whiteSpace(x)
    }));
    return arr;
  }

  static getBearerToken(token: string): string {
    return `Bearer ${token}`;
  }

  static padLeftZeros(str: any, max: number): string {
    str = str.toString();

    return str.length < max ? PWUtils.padLeftZeros('0' + str, max) : str;
  }

  static toUtcDate(date: Date): Date {
    return date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
      date.getHours(), date.getMinutes(), date.getSeconds())) : undefined;
  }

  static numberWithCommas(value: number): string {
    const numberWithCommasRegex = new RegExp('\\B(?=(\\d{3})+(?!\\d))', 'g');

    return value.toString().replace(numberWithCommasRegex, ',');
  }

  static dateFormat(date: Date, format: string): string {
    return new DatePipe('en-US').transform(date, format);
  }

  static isNotEmpty(obj: any): boolean {
    return obj !== undefined && obj !== null && (obj.constructor.name === 'String' ? obj.trim() !== '' : true);
  }

  static toCamcelCase(text: string): string {
    const regEx = /(?:^\w|[A-Z]|\b\w)/g;
    return text.replace(regEx, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  static toCapitalCase(text: string): string {
    if (text) {
      const regEx = /([A-Z])/g;
      return text.toString().replace(regEx, ' $1').replace(/^./, (str) => {
        return str.toUpperCase();
      });
    }
    return null;
  }

  static shortDateTime(date: Date, showTime = false): string {
    const now = new Date();
    const time = PWUtils.dateFormat(date, 'shortTime');
    if (date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) {
      if (date.getDate() === now.getDate()) {
        return showTime ? time : 'Today';
      }
      if (date.getDate() + 1 === now.getDate()) {
        return 'Yesterday' + (showTime ? ' ' + time : '');
      }
    }

    return PWUtils.dateFormat(date, 'dd MMM y') + (showTime ? ', ' + time : '');
  }

  static dateTimeAgo(date: Date): string {
    const minsDiff = Math.round(((new Date()).getTime() - date.getTime()) / 1000 / 60);
    if (minsDiff < 60) {
      return minsDiff + ' mins ago';
    }

    const hoursDiff = Math.floor(minsDiff / 60);
    if (hoursDiff < 24) {
      return hoursDiff + ' hours ' + (minsDiff - hoursDiff * 60) + ' mins ago';
    }

    return PWUtils.dateFormat(date, 'h:mm a, dd-MM-y');
  }

  static currentTimezone(): number {
    return -(new Date()).getTimezoneOffset() / 60;
  }

  static classType(type: any) {
    const result = () => type;

    return result;
  }

  static convertNumberToWords(amount): string {
    amount = amount.toString().replace(/,/g, '');
    const arr = amount.split('.');
    if (amount.indexOf('.') !== -1) {
      if (arr[1] === '00') {
        return (`Ringgit Malaysia ${numberToWords.toWords(arr[0])} Only`).toUpperCase();
      }
      return (`Ringgit Malaysia ${numberToWords.toWords(arr[0])} And Cents ${numberToWords.toWords(arr[1])} Only`).toUpperCase();
    }
    return (`Ringgit Malaysia ${numberToWords.toWords(amount)} Only`).toUpperCase();
  }

  private static buildFormData(formData: FormData, data: any, rootName = '') {
    if (Array.isArray(data) && data[0] instanceof FileModel) {
      data.forEach((file: FileModel) => {
        formData.append(rootName, (file.fileBlob instanceof Blob) ?
          file.fileBlob : (file.fileBlob as any).name[0], file.fileName);
      });
    } else if (data instanceof Date) {
      formData.append(rootName, data.toISOString());
    } else if (Array.isArray(data)) {
      data.forEach((value, index) => this.buildFormData(formData, value, `${rootName}[${index}]`));
    } else if (typeof data === 'object' && data) {
      Object.keys(data).forEach(key => {
        if (data.hasOwnProperty(key)) {
          if (rootName === '') {
            this.buildFormData(formData, data[key], key);
          } else {
            this.buildFormData(formData, data[key], `${rootName}[${key}]`);
          }
        }
      });
    } else {
      formData.append(rootName, data);
    }
  }

  static toFormData(object: any): FormData {
    const formData = new FormData();
    this.buildFormData(formData, object);
    return formData;
  }

  static whiteSpace(value: string): string {
    const res = value.replace(/([A-Z])/g, ' $1');
    return res;
  }

  static getLastSunday(fromDate: Date) {
    const date = new Date(fromDate);
    const today = date.getDate();
    const dayOfTheWeek = date.getDay();
    const newDate = date.setDate(today - (dayOfTheWeek || 7));
    return new Date(newDate);
  }
}
